import envVar from '../config/envVars';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

const getSkills = async (
  grade: string,
  division: string,
  academicYear: string,
  school: string
) => {
  return httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/grade/${grade}/division/${division}/skills?academicYear=${academicYear}`,
    {
      headers: { Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}` }
    }
  );
};

interface SubSkillInput {
  id?: string;
  description: string;
  scoringType: string;
  order: number;
  maxMarks?: number;
}

interface UpsertSkillPayload {
  id?: string;
  skillName: string;
  subSkills: SubSkillInput[];
  academicYear: string;
}

const upsertSkill = async (
  school: string,
  grade: string,
  division: string,
  payload: UpsertSkillPayload
) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/grade/${grade}/division/${division}/skills/upsert`,
    payload,
    {
      headers: { Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}` }
    }
  );
};

interface CloneSkillsPayload {
  cloneFrom: { academicYear: string; grade: string; division: string };
  cloneTo: { academicYear: string; grade: string; division: string };
}

const cloneSkills = async (school: string, payload: CloneSkillsPayload) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/skills/clone`,
    payload,
    {
      headers: { Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}` }
    }
  );
};

const skillApis = { getSkills, upsertSkill, cloneSkills };
export default skillApis;
